<template>
  <template-user-post-list-page></template-user-post-list-page>
</template>

<script lang="ts">

import templateUserPostListPage from '@/app-template/lib/pages/UserPostListPage.vue';

export default {
  name: "UserPostListPage",
  components: { templateUserPostListPage },
};
</script>